// src/pages/settings/forms/builderDrawer/Toolbox.tsx
import React from "react";
import { Typography } from "antd";
import { DraggableElement } from "./elements/DraggableElement";
import { paletteElements } from "./formElementTypes";

const { Text } = Typography;

interface ToolboxProps {}

export const Toolbox: React.FC<ToolboxProps> = () => {
	// Shared with the per-field type selector in BuilderCanvas — see formElementTypes.ts.
	const formElements = paletteElements();

	return (
		<div
			style={{
				width: 210,
				flexShrink: 0,
				height: "100%",
				overflowY: "auto",
				overflowX: "hidden",
				background: "var(--mg-bg-elevated)",
				borderRight: "1px solid var(--mg-border)",
				padding: 12,
				display: "flex",
				flexDirection: "column",
				gap: 0,
			}}
		>
			{/* Palette header */}
			<div style={{ marginBottom: 8 }}>
				<Text strong style={{ fontSize: 13, color: "var(--mg-text)" }}>
					Elements
				</Text>
			</div>
			<div style={{ borderBottom: "1px solid var(--mg-border)", marginBottom: 10 }} />

			{/* Draggable items */}
			<div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
				{formElements.map((element, index) => {
					const draggableId = `${element.type}-${index}`;
					return <DraggableElement key={draggableId} element={element} draggableId={draggableId} />;
				})}
			</div>

			{/* Tip callout — Section 16.3 */}
			<div
				style={{
					marginTop: 16,
					background: "var(--mg-bg-subtle)",
					border: "1px solid var(--mg-border)",
					borderRadius: 6,
					padding: "8px 10px",
					color: "var(--mg-text-secondary)",
					fontSize: 11,
					lineHeight: 1.5,
				}}
			>
				💡 Drag elements onto the canvas to build your form
			</div>
		</div>
	);
};
